<style scoped>
* {
  text-align: left;
}
.van-icon-search {
  color: #df2f2f;
  font-size: 20px;
}
.van-search .van-cell {
  padding: 6px 8px 6px 0;
}
.van-search__action {
  color: #fff;
}
.van-search__action:active {
  background: none;
}
</style>
<template>
  <div class="search">
    <form v-on:submit.prevent="onSearch" action="">
      <van-search
        v-model="value"
        show-action
        autofocus="true"
        shape="round"
        background="#df2f2f"
        @search="onSearch"
        @input="onInput"
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div @click="onBack">取消</div>
        </template>
      </van-search>
    </form>
    <van-empty v-show="onDesc" image="search" description="请输入搜索关键词" />
    <van-list v-show="onShow">
      <van-cell
        v-for="(item,index) in list"
        :key="index"
        @click="onSearchClick(item)"
      >
      <template #title >
        <span style="color:rgb(223, 47, 47); padding-right:2px">{{item.title}}</span>{{item.tag}}
      </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      value: "",
      list: [],
      onShow: false,
      onDesc: true,
    };
  },
  name: "Search",
  created: function () {},

  methods: {
    onBack() {
      this.$router.go(-1); //返回上一层n
    },
    onSearch() {
      if (this.value == "") {
        Toast("请输入搜索内容");
      } else {
        this.onDesc = false;
        this.onShow = true;
        this.$router.replace({ name: "Home", query: { search: this.value } });
      }
    },
    onSearchClick(value) {
      this.$router.replace({ name: "Home", query: { search: this.value } });
    },
    onInput() {
      if (this.value) {
        var array = (this.list = []);
        var val = this.value;
        var stuffs = ["租房", "新房", "二手房", "商铺", "地产"];
        stuffs.forEach(function (v) {
          array.push( {title:val,tag: v});
        });
        this.onDesc = false;
        this.onShow = true;
      } else {
        this.onDesc = true;
        this.onShow = false;
      }
    },
  },
};
</script>
